/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Cta_BtnInputs */

const en_rd_cta_btn = /** @type {(inputs: Rd_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan it with Bystep`)
};

const id_rd_cta_btn = /** @type {(inputs: Rd_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanakan dengan Bystep`)
};

/**
* | output |
* | --- |
* | "Plan it with Bystep" |
*
* @param {Rd_Cta_BtnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_cta_btn = /** @type {((inputs?: Rd_Cta_BtnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Cta_BtnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_cta_btn(inputs)
	return en_rd_cta_btn(inputs)
});